import React, { useContext } from 'react';
import { FaFolder, FaUndo, FaCalendar, FaUser, FaBuilding, FaComment } from 'react-icons/fa';
import { NavLink} from 'react-router-dom';
import { Menu} from 'antd';

import {
  ADMIN_AIRBNB_GESTION_COMMENTAIRE,
  ADMIN_AIRBNB_GESTION_LOGEMENT,
  ADMIN_AIRBNB_GESTION_RESERVATION,
  ADMIN_AIRBNB_USER,
  ADMIN_PARTENAIRE_AIRBNB_GESTION_PARTENAIRE,
  ADMIN_PARTENAIRE_AIRBNB_MESDOCUMENTS,
  ADMIN_PARTENAIRE_AIRBNB_RESILIER_CONTRAT,
  SUPER_ADMIN_OWNER_AIRBNB
} from 'settings/constant';
import { AuthContext } from 'context/AuthProvider';

const AdminPartenaireAirBnbSideMenu = () => {
  const { user } = useContext(AuthContext);

    let navigations = [
        {
            label: <NavLink to={ADMIN_PARTENAIRE_AIRBNB_GESTION_PARTENAIRE}>Partenaire</NavLink>,
            key: 'loueur_airbnb',
            icon: <FaFolder className='AirBnb' />
        },
        {
            label: <NavLink to={ADMIN_AIRBNB_GESTION_LOGEMENT}>Logements</NavLink>,
            key: 'logement',
            icon: <FaBuilding className='Logement' />
        },
        {
            label: <NavLink to={ADMIN_AIRBNB_GESTION_RESERVATION}>Réservations</NavLink>,
            key: 'reservation',
            icon: <FaCalendar className='Reservation' />
        }
    ];

  if (user.roles.includes('ROLE_SUPER_ADMIN')
    || user.roles.includes('ROLE_MANAGER')
    || user.roles.includes('ROLE_AGENT_COM')
    || user.roles.includes('ROLE_ADMIN_HOTEL')) {
    navigations.push({
      label: <NavLink to={ADMIN_AIRBNB_GESTION_COMMENTAIRE}>Commentaires</NavLink>,
      key: 'commentaireAirbnb',
      icon: <FaComment className='commentaireAirbnb' />
    })
  }

  if (user.roles.includes('ROLE_SUPER_ADMIN')
    || user.roles.includes('ROLE_ADMIN_HOTEL')) {
    navigations.push(
      {
        label: <NavLink title='Mes documents' to={ADMIN_PARTENAIRE_AIRBNB_MESDOCUMENTS}>Mes documents</NavLink>,
        key: 'mesDocumens',
        icon: <FaFolder className='MesDocuments' />
      }
    );
    navigations.push(
      {
        label: <NavLink title='Résilier contrat' to={ADMIN_PARTENAIRE_AIRBNB_RESILIER_CONTRAT}>Résilier contrat</NavLink>,
        key: 'resilierContrat',
        icon: <FaFolder className='ResilierContrat' />
      }
    );
  }

  if (user.roles.includes('ROLE_SUPER_ADMIN')
    || user.roles.includes('ROLE_MANAGER')
    || user.roles.includes('ROLE_AGENT_COM')
    || user.roles.includes('ROLE_ADMIN_HOTEL')) {
    navigations.push({
      label: <NavLink to={ADMIN_AIRBNB_USER}>Utilisateurs</NavLink>,
      key: 'user',
      icon: <FaUser className='user' />
    })
  }

  if (user.roles.includes('ROLE_SUPER_ADMIN')
    || user.roles.includes('ROLE_MANAGER')
    || user.roles.includes('ROLE_AGENT_COM')) {
    navigations.push({
      label: <NavLink to={SUPER_ADMIN_OWNER_AIRBNB}>Retour</NavLink>,
      key: 'Undu',
      icon: <FaUndo className='Undu' />
    })
  }

  return (
    <>
      <Menu
        defaultSelectedKeys={['1']}
        defaultOpenKeys={['AirBnb']}
        mode="inline"
        items={navigations}
      />
    </>
  );
};

export default AdminPartenaireAirBnbSideMenu;